<template>
  <div>
    <template v-if="loading">
      <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
    </template>
    <template v-else-if="supportDetail">
      <p>{{$t('If you have any question, contact your supporter here')}}</p>
      <div class="z-border-red pa-2">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <img :src="supportDetail.photo" @error="onError" />
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title v-html="supportDetail.fullname"></v-list-tile-title>
            <v-list-tile-sub-title v-html="supportDetail.contact"></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </div>
    </template>
    <div class="form-control" v-else :class="{'has-error': errors.has('supportcode')}">
      <input
        type="text"
        :placeholder="$t('Support code')"
        :data-vv-as="$t('Support code')"
        name="supportcode"
        v-model="supportcode"
        v-validate="'required|min:5'"
        maxlength="20"
        style="text-transform: uppercase;"
      />

      <div class="text-xs-left">
        <span
          class="text-error"
          v-show="errors.has('supportcode')"
        >{{ errors.first('supportcode') }}</span>
      </div>

      <v-btn outline color="primary" @click="onSavesupportCode">{{$t('Save')}}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
export default {
  data: () => {
    return {
      supportcode: null,
      supportDetail: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  components: {
    VueRecaptcha,
    ScaleLoader
  },
  directives: {
    uppercase: {
      update(el) {
        el.value = el.value.toUpperCase()
      }
    }
  },
  mounted: function() {
    var vm = this
    vm.$store.dispatch('updateBotDetail').then(
      function() {
        if (vm.selectedBot.supportusers) {
          vm.loading = true
          vm.getSupportUser().then(
            function() {
              vm.loading = false
            },
            function() {
              vm.loading = false
            }
          )
        } else {
          vm.loading = false
        }
      },
      function() {
        vm.loading = false
      }
    )
  },
  methods: {
    onError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    getSupportUser: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          supportusers: vm.selectedBot.supportusers
        }
        api.getSupportUser(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.supportDetail = response.data
          }
          resolve()
        })
      })
    },
    onSavesupportCode() {
      let vm = this
      vm.$validator.validate().then(result => {
        if (!result) {
          return false
        }
        var data = {
          pageid: vm.selectedBot.pageid,
          supportcode: vm.supportcode.toUpperCase()
        }
        vm.loading = true
        api.saveSupportusers(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.loading = false
            return
          }

          if (response.data) {
            vm.supportDetail = response.data
            vm.$swal
              .fire({
                title: vm.$t('Successfully'),
                text: vm.$t('you got {day} days for using Premium Package', {
                  day: response.freetrial
                }),
                type: 'success',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('cancel'),
                reverseButtons: true
              })
              .then(result => {
                if (result.value) {
                  vm.$emit('updateSupportCode')
                }
              })
            vm.loading = false
          } else {
            vm.$swal.fire({
              title: vm.$t('Code ไม่ถูกต้อง'),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
            vm.loading = false
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/billing/SupportCode.vue